import { documentApi } from '@/boot-api/record'
export default {
    methods: {
        exportPdf(id) {
            this.$msgbox({
                title: '导出提示',
                showConfirmButton: false,
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                message: <div style="width:100%;"><i class="el-icon-loading" style="margin-right:10px" />
                    正在导出中，需要一点时间。请稍等</div>
            })
            documentApi.toPdf({ id }).then(res => {
                if (res.data) {
                    window.open(res.data.url)
                } else {
                    this.$message.error("导出失败")
                }
                this.$msgbox.close()
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/views/record/record-mixin.js